var map = {
	"./vip-1.gif": 2006,
	"./vip-1.svg": 2007,
	"./vip-10.gif": 2008,
	"./vip-10.svg": 2009,
	"./vip-11.gif": 2010,
	"./vip-11.svg": 2011,
	"./vip-12.gif": 2012,
	"./vip-12.svg": 2013,
	"./vip-2.gif": 2014,
	"./vip-2.svg": 2015,
	"./vip-3.gif": 2016,
	"./vip-3.svg": 2017,
	"./vip-4.gif": 2018,
	"./vip-4.svg": 2019,
	"./vip-5.gif": 2020,
	"./vip-5.svg": 2021,
	"./vip-6.gif": 2022,
	"./vip-6.svg": 2023,
	"./vip-7.gif": 2024,
	"./vip-7.svg": 2025,
	"./vip-8.gif": 2026,
	"./vip-8.svg": 2027,
	"./vip-9.gif": 2028,
	"./vip-9.svg": 2029,
	"./vip-bg.jpg": 2030,
	"./vip10-bg.jpg": 2031,
	"./vip11-bg.jpg": 2032,
	"./vip12-bg.jpg": 2033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2005;